import React from 'react'
import ReactDOM from 'react-dom'

import { Provider } from 'react-redux'
import { Router, browserHistory } from 'react-router'

import { routes } from '../app/routes'

import { CLIENT_INIT } from '../app/actions/client-only'

const initialState = window.__INITIAL_STATE__

let store = require('../app/redux-store')
store = store.configureStore(initialState)

ReactDOM.render(
  <Provider store={store}>
    <Router history={browserHistory} routes={routes}/>
  </Provider>,
  document
)



// WEBPACK FOOTER //
// ./src/client/index.js